<template>
  <v-container fluid class="px-0">
    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('Filtras') }}</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6">
              <el-text-field
                label="Institucijos pavadinimas (LT)"
                v-model="mainData['title_lt-search-like']"
                hide-details
                :maxlength="200"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-text-field
                label="Institucijos pavadinimas (EN)"
                v-model="mainData['title_en-search-like']"
                hide-details
                :maxlength="200"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-autocomplete
                :items="classifiers['institution-group']"
                itemvalue="value"
                itemtext="text"
                :multiple="true"
                label="Institucijos grupės"
                v-model="mainData['institution_group_id-search-custom']"
              />
            </v-col>
              <v-col cols="12" md="3">
              <el-text-field
                label="Juridinio asmens kodas"
                v-model="mainData['code-search-like']"
                hide-details
                :maxlength="20"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                class="mr-1"
                title="Ieškoti"
                :loading="loading"
                color="primary"
                icon="ieškoti"
                @click.native.stop="searchData()"
              />
              <el-button
                color="secondary"
                icon="išvalyti"
                title="Išvalyti"
                :loading="loading"
                @click.native="clearData()"
              />
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InstitutionsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    loadDefault: null,
    mainData: {},
    classifiers: [],
    extraData: {
      objektas: null,
      veiksmas: [],
      rusys: {},
    },
    enableVeiksmas: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
  },
  methods: {
    getClassifiers() {
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['institution-group'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
          }

          this.searchData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...(this.loadDefault ? this.extraData : {}),
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
        rusys: {},
      }
      this.searchData()
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
